import {AfterViewInit, Directive, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FieldType, FormlyModule} from '@ngx-formly/core';
import {ReactiveFormsModule} from '@angular/forms';
import {JigsawTrustedHtmlModule} from "@rdkmaster/jigsaw";
import {FormlyWrapperFormField} from './form-field.wrapper';

@NgModule({
    declarations: [FormlyWrapperFormField],
    imports: [
        CommonModule,
        ReactiveFormsModule,
        JigsawTrustedHtmlModule,
        FormlyModule.forChild({
            wrappers: [{
                name: 'form-field',
                component: FormlyWrapperFormField,
            }],
        }),
    ],
})
export class FormlyJigsawFormFieldModule {
}

/**
 * å°ç»ä»¶çå®ä¾ï¼æå°toä¸ï¼è¿æ ·å¨åºç¨ä¸­ï¼å°±å¯ä»¥éè¿fieldConfigå¯¹è±¡éé¢çtoå±æ§ï¼æ¿å°è¯¥ç»ä»¶çå®ä¾äº
 */
@Directive()
export abstract class FormlyFieldType<T> extends FieldType implements AfterViewInit {
    protected _instance: T;

    ngAfterViewInit(): void {
        this.to.componentRef = this._instance;
    }
}

